import { mapActions, mapGetters, mapMutations } from 'vuex';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default {
  name: 'SMSModal',
  components: {},
  data() {
    return {
      phone: '',
      prevStatePhone: '',
      agree: false,
      registrationType: 2,
      countryCode: 'UA',
      payload: {
        sms: '',
        phone: ''
      }
    };
  },
  created() {
    document.getElementById('html').classList.add('hide');
  },
  watch: {
    'payload.sms': function () {
      this.$refs.smsError.innerHTML = '';
    },
    phone(value) {
      const parsedNumber = parsePhoneNumberFromString(value);
      if (parsedNumber) {
        this.countryCode = parsedNumber.country;
      } else {
        this.countryCode = '';
      }
    }
  },
  computed: {
    ...mapGetters({
      smsCodeRequested: 'auth/smsCodeRequested',
      verifyCodeResponse: 'auth/verifyCodeResponse',
      verifyCodeLoading: 'auth/verifyCodeLoading',
      smsCodeLoading: 'auth/smsCodeLoading'
    })
  },
  methods: {
    ...mapMutations({
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      modalOpen: 'app/MODAL_OPEN',
      modalClose: 'app/MODAL_CLOSE'
    }),
    ...mapActions({
      sendPhone: 'auth/SEND_CODE',
      sendCode: 'auth/VERIFY_CODE'
    }),
    async sendSmsCode() {
      if (!this.countryCode) {
        /*invalid phone*/
        this.$refs.phoneError.innerHTML = this.$t('validation.minLength', { size: 13 });
        return;
      }

      try {
        this.prevStatePhone = this.phone;
        const response = await this.sendPhone({
          phone: this.phone,
          phone_country: this.countryCode
        });

        /** @type {ISendCodeResponse} */
        const data = response.data;

        this.$refs.smsError.innerHTML = '';
        this.$toasted.success(data.message);

        if (data.codeMessage) {
          this.$toasted.success(data.codeMessage);

          this.payload.sms = data.debug.code;
        }
      } catch (error) {
        this.$refs.smsError.innerHTML = error.data.message;
      }
    },
    async _verifyPhoneAndCode() {
      if (this.payload.sms.length !== 6) {
        this.$refs.smsError.innerHTML = this.$t('validation.minLength', { size: 6 });
        return;
      }

      try {
        const response = await this.sendCode({
          code: this.payload.sms,
          phone: this.phone,
          phone_country: this.countryCode
        });
        /** @type {IVerifyCodeResponse} */
        const data = response.data;

        this.$toasted.success(data.message);

        this.modalClose('phoneRegister');
        this.modalOpen('registration');

        this.$refs.smsError.innerHTML = '';
      } catch (error) {
        this.$refs.smsError.innerHTML = error.data.message;
        // this.$toasted.error(error.data.message);
      }
    },
    async onSubmit() {
      if (!this.smsCodeRequested) {
        await this.sendSmsCode();
        return;
      }

      await this._verifyPhoneAndCode();
    },
    onClearApiError() {
      if (this.$refs.smsError.innerHTML && this.prevStatePhone >= this.phone) {
        this.$refs.smsError.innerHTML = '';
        this.prevStatePhone = '';
      }
    }
  }
};
